import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import { downloadFile } from 'utils/helpers';
import http from 'utils/http';

const fetchImportScheduleSample = () => {
  const newEndpoints = endpoints.scheduling.downloadImportScheduleSample;
  return http()
    .get(newEndpoints, { responseType: 'blob' })
    .then(res => new Blob([res]))
    .then(blob => {
      downloadFile(blob, 'schedule-sample.csv');
      return null;
    });
};

export function useFetchImportScheduleSample(options?: any): UseQueryResult<any> {
  return useQuery({ queryKey: ['fetchImportScheduleSample'], queryFn: () => fetchImportScheduleSample(), ...options });
}
